<template>
  <NuxtLoadingIndicator color="#1ccb01" error-color="#fa1255" />
  <NuxtLayout>
    <NuxtPage />
    <ClientOnly>
      <AsyncBaseNotificationList />
    </ClientOnly>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  const AsyncBaseNotificationList = defineAsyncComponent(
    () => import('~/components/base-ui/notifications/BaseNotificationList.vue')
  )

  useSeoMetadata()
</script>
